import { filterItemGroups } from '@/experiences/sales-portal/domain/order-guides/screens/order-guides-list/blocs/transformers/filter-item-groups';
import { ItemGroup } from '@/experiences/sales-portal/domain/order-guides/blocs/transformers/group-by-item';
import { OrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/types';
import { useDeferredValue, useMemo, useState } from 'react';

interface FilteredItemGroups {
  deferredSearchTerm: string;
  filteredItemGroups: ItemGroup<OrderGuideItem>[];
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

/**
 * Owns the in-guide search term and derives the visible item groups.
 */
export const useFilteredItemGroups = (
  itemGroups: ItemGroup<OrderGuideItem>[],
): FilteredItemGroups => {
  const [searchTerm, setSearchTerm] = useState('');
  // Defer the filter so typing stays responsive: the input tracks `searchTerm`
  // while the heavy list re-render runs at low priority off `deferredSearchTerm` and yields to newer keystrokes.
  const deferredSearchTerm = useDeferredValue(searchTerm);
  const filteredItemGroups = useMemo(
    () => filterItemGroups(itemGroups, deferredSearchTerm),
    [itemGroups, deferredSearchTerm],
  );

  return { deferredSearchTerm, filteredItemGroups, searchTerm, setSearchTerm };
};
